import React, { useContext, useEffect } from 'react';
import { LocaleContext, AuthContext } from '../locale';
import './AdminWelcome.css';

export default function AdminWelcome() {
  const { t } = useContext(LocaleContext);
  const { user, logout, openAuth } = useContext(AuthContext);

  // Protect: redirect non-admins
  useEffect(() => {
    if (!user) {
      openAuth && openAuth('login');
      window.location.hash = '#/';
    } else if (user.role !== 'admin') {
      window.location.hash = '#/';
    }
  }, [user, openAuth]);

  if (!user || user.role !== 'admin') return null;

  return (
    <section className="admin-welcome">
      <div className="container">
        <div className="admin-header">
          <div className="admin-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
          </div>
          <h1 className="admin-title">Hello Admin</h1>
          <p className="admin-subtitle">Welcome to the administrative dashboard</p>
        </div>

        <div className="admin-content">
          <div className="welcome-card">
            <div className="card-header">
              <h2>Welcome back, {user?.fullName || 'Administrator'}</h2>
              <p>You are logged in as an administrator</p>
            </div>
            
            <div className="admin-stats">
              <div className="stat-card">
                <div className="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <div className="stat-info">
                  <h3>Users</h3>
                  <p>Manage user accounts</p>
                </div>
              </div>

              <div 
                className="stat-card clickable"
                onClick={() => { window.location.hash = '#/admin/orders'; }}
                role="button"
                tabIndex={0}
                title="Track and manage orders"
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') window.location.hash = '#/admin/orders'; }}
              >
                <div className="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                </div>
                <div className="stat-info">
                  <h3>Orders</h3>
                  <p>Track and manage orders</p>
                </div>
              </div>

              <div 
                className="stat-card clickable"
                onClick={() => { window.location.hash = '#/admin/products'; }}
                role="button"
                tabIndex={0}
                title="Manage product catalog"
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') window.location.hash = '#/admin/products'; }}
              >
                <div className="stat-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                    <line x1="8" y1="21" x2="16" y2="21"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                  </svg>
                </div>
                <div className="stat-info">
                  <h3>Products</h3>
                  <p>Manage product catalog</p>
                </div>
              </div>
            </div>

            <div className="admin-actions">
              <button 
                className="btn primary" 
                onClick={() => {
                  window.location.hash = '#/admin/add-product';
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{marginRight: 8}}>
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="16"/>
                  <line x1="8" y1="12" x2="16" y2="12"/>
                </svg>
                Ajouter un produit
              </button>
              
              <button className="btn secondary" onClick={logout}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{marginRight: 8}}>
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16,17 21,12 16,7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
